import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import href from '#utilities/js/ea/href.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import dragEnd from '@mailobj-browser/front/js/events/types/dragEnd.js'
import rect from '#utilities/js/ea/rect.js'
import * as generics from '#components/generics/js/styles.js'
import { elements } from '../../../styles.js'
import { get } from '#utilities/js/ea/ajax.js'
import { close } from '#utilities/js/lightboxes/lightbox.js'
import dragStart from '@mailobj-browser/front/js/events/types/dragStart.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

let shiftX = 0
let shiftY = 0

const onDragStart = object(listener, {
  type: dragStart,
  passive,
  task: (
    magnet,
    { clientX, clientY }
  ) => {
    const { top, left } = rect(magnet)

    shiftX = clientX - left
    shiftY = clientY - top
  }
})

const onDragEnd = object(listener, {
  type: dragEnd,
  passive,
  task: async (
    magnet,
    { clientX, clientY }
  ) => {
    if (closest(`.${generics.elements.modal}`, magnet)) {
      return
    }

    const { dataset: magnetDataset, ownerDocument, parentNode } = magnet
    const container = one(`.${elements.fridge_container}`, ownerDocument)
    const { dataset: parentDataset } = parentNode
    const { dataset: containerDataset } = container
    const { editable } = parentDataset
    const { template } = magnetDataset
    const { space, fridge, spaceType } = containerDataset
    const { left, right, top, bottom } = rect(container)
    const { height, width } = rect(magnet)

    let xMagnet = clientX - shiftX - left
    let yMagnet = clientY - shiftY - top

    if (clientX < left || clientY < top || clientX > right || clientY > bottom) {
      return
    }

    if (yMagnet < 0) {
      yMagnet = 0
    }

    if (clientX - shiftX + width > right) {
      xMagnet = xMagnet - (width - (right - xMagnet)) - left
    }

    if (clientY - shiftY + height > bottom) {
      yMagnet = yMagnet - (height - (bottom - yMagnet)) - top
    }

    if (xMagnet < 0) {
      xMagnet = 0
    }

    sendForm(space, spaceType, fridge, template, editable, magnet, xMagnet, yMagnet).then(() => {
      console.info('Magnet added')
    })
  }
})

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    magnet
  ) => {
    const { dataset: magnetDataset, ownerDocument } = magnet
    const section = closest(`.${elements.fridge_new}`, magnet)
    const container = one(`.${elements.fridge_container}`, ownerDocument)
    const { dataset: sectionDataset } = section
    const { dataset: containerDataset } = container
    const { editable } = sectionDataset
    const { template } = magnetDataset
    const { space, fridge, spaceType } = containerDataset

    sendForm(space, spaceType, fridge, template, editable, magnet, 0, 0).then(() => {
      console.info('Magnet added')
    })

    close()
  }
})

const sendForm = async (space, spaceType, fridge, template, editable, magnet, xPos, yPos) => {
  const url = href('space/req_fridge', {
    act: 'add',
    magnet_text: '',
    magnet_xpos: xPos,
    magnet_ypos: yPos,
    magnet_template: template,
    magnet_type: editable,
    space,
    fridge,
    space_type: spaceType,
    update: 1
  })

  try {
    await get(url, { target: magnet })
  } catch (e) {
    console.error(e)
  }
}

export default element => {
  onClick.listen(element)
  onDragStart.listen(element)
  onDragEnd.listen(element)
}
